<template>
  <div v-if="ready">
    <q-input
      v-model="filter"
      stack-label="Filter"
      clearable
      class="q-mb-sm"
    />
    <q-tree
      :nodes="nodes"
      node-key="id"
      :filter="filter"
      label-key="description"
      v-if="nodes && nodes.length"
      :ticked.sync="ticked"
      tick-strategy="strict"
    >
      <div slot="default-header" slot-scope="prop" class="row items-center">
        <q-btn v-if="prop && prop.node && prop.node.id" icon="edit" size="xs" flat class="q-mr-sm" @click="$router.push(`/company/csi-codes/edit/${prop.node.id}`)" />
        <div class="text-weight-bold text-primary">{{ prop.node.description }}</div>
      </div>
    </q-tree>
    <q-alert color="warning" v-else>
      No Nodes Found
    </q-alert>
    <q-page-sticky position="bottom-right" :offset="[70, 18]" style="width: 20%" expand>
      <q-card style="background: white; width: 100%;">
        <q-card-title>
          Move Selected Codes:
        </q-card-title>
        <q-card-separator />
        <q-card-main>
          <div class="row q-mb-lg">
            <div class="col-12 q-pr-sm">
              <q-select
                v-if="parents && parents.length"
                v-model="parentSelect"
                float-label="New Parent"
                :options="parents"
                filter
                autofocus-filter
              />
            </div>
          </div>
          <div class="row q-mb-lg">
            <div class="col-6 q-pr-sm">
              <q-btn color="secondary" @click="handleMove" class="full-width" push size="lg" :disabled="ticked.length <= 0 || parentSelect === null || parentSelect === ''">Move</q-btn>
            </div>
            <div class="col-6 q-pr-sm">
              <q-btn color="primary" @click="handleSave" class="full-width" push size="lg" :disabled="!dataChanged">Save</q-btn>
            </div>
          </div>
        </q-card-main>
      </q-card>
    </q-page-sticky>
  </div>
</template>

<script>

export default {
  name: "SimpleTree",
  props: {
    resource: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      ready: false,
      ticked: [],
      selected: null,
      filter: '',
      parentSelect: '',
      nodes: [],
      dataChanged: false
    }
  },
  computed: {
    parents() {
      if (this.nodes && this.nodes.length) {
        const filteredNodes = this.nodes.filter(node => node.parentId === 1)
        const noParent = {label: 'No Parent -> Make a Parent', value: 1}
        if (filteredNodes && filteredNodes.length) {
          let returnArray = filteredNodes.map(node => {
            return {
              label: node.description,
              value: node.id
            }
          })
          returnArray.unshift(noParent)
          return returnArray
        }
      }
      return []
    }
  },
  methods: {
    handleMove () {
      this.$set(this, 'dataChanged', true)
      let nodes = [...this.nodes]
      let movingIndexes = []
      let movingObjects = []
      let foundError = false
      for (let tickedId of this.ticked) {
        let movingIndex = this.findIndexes(tickedId, nodes)
        if (movingIndex.parentIndex >= 0 || movingIndex.childIndex >= 0) {movingIndexes.push(movingIndex)}
        let movingObject = this.findObjects(movingIndex, nodes)
        if (movingObject.children.length) {
          alert('You are trying to move a parent with children.  Please remove / move the children from the parent before moving the parent.')
          foundError = true
        }
        if (movingObject) {movingObjects.push(movingObject)}
        if (movingIndex.parentIndex >= 0 && !movingIndex.childIndex && movingIndex.childIndex !== 0) {
          nodes = nodes.filter(node => node.id !== tickedId)
        } else if (movingIndex.childIndex >= 0 && movingIndex.parentIndex >= 0) {
          nodes[movingIndex.parentIndex].children = nodes[movingIndex.parentIndex].children.filter(child => child.id !== tickedId)
        }
      }
      for (let movingObject of movingObjects) {
        movingObject.isDirty = true
        movingObject.parentId = this.parentSelect
      }
      const parentIndex = nodes.findIndex(node => node.id === this.parentSelect)
      if (this.parentSelect === 1) {
        for (let movingObject of movingObjects) {
          nodes.push(movingObject)
        }
      } else if (parentIndex !== -1) {
        for (let movingObject of movingObjects) {
          nodes[parentIndex].children.push(movingObject)
        }
        nodes[parentIndex].children.sort((a, b) => a.description.localeCompare(b.description))
      } else {
        alert('Parent not found or you have the selected and new parent as the same.')
        foundError = true
      }
      if (!foundError) {
        this.$set(this, 'ticked', [])
        this.$set(this, 'nodes', nodes.sort((a, b) => a.description.localeCompare(b.description)))
      }
    },
    findIndexes(id, nodes) {
      let returnObject = {
        parentIndex: null,
        childIndex: null,
      }
      const parentIndex = nodes.findIndex(node => node.id === id)
      if (parentIndex !== -1) {
        returnObject.parentIndex = parentIndex
      } else {
        let i;
        for (i = 0; i < nodes.length; i++) {
          // for (let node of this.nodes) {
          const childIndex = nodes[i].children.findIndex(node => node.id === id)
          if (childIndex !== -1) {
            returnObject.parentIndex = i
            returnObject.childIndex = childIndex
          }
        }
      }
      return returnObject
    },
    findObjects(movingIndex, nodes) {
      if (movingIndex.parentIndex >= 0 && !movingIndex.childIndex && movingIndex.childIndex !== 0) {
        return nodes[movingIndex.parentIndex]
      } else if (movingIndex.childIndex >= 0 && movingIndex.parentIndex >= 0) {
        return nodes[movingIndex.parentIndex].children[movingIndex.childIndex]
      } else {
        return {}
      }
    },
    collectDirtyObjects() {
      let dirtyObjects = []
      const dirtyParents = this.nodes.filter(node => node.isDirty)
      if (dirtyParents && dirtyParents.length) {
        dirtyObjects = [...dirtyParents]
      }
      for (const node of this.nodes) {
        const dirtyChildren = node.children.filter(child => child.isDirty)
        if (dirtyChildren && dirtyChildren.length) {
          dirtyObjects = [...dirtyObjects, ...dirtyChildren]
        }
      }
      return dirtyObjects
    },
    async handleSave() {
      const dirtyObjects = this.collectDirtyObjects()
      try {
        const {data} = await this.$axios.put(this.$store.state[this.resource].apiHierarchyEndpoint, dirtyObjects)
        if (data) {
          console.log('Save Data: ', data)
          this.$q.notify({
            type: 'positive',
            message: 'Changes have been saved'
          })
        } else {
          this.$q.notify({
            type: 'negative',
            message: 'Error saving'
          })
        }
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          message: 'Error saving'
        })
      }
    },
    async fetchNodes () {
      // console.log('this.$store.state', this.$store.state, 'this.resource', this.resource)
      // console.log('fetchNotes', this.$store.state[this.resource].apiHierarchyEndpoint)
      try {
        const {data} = await this.$axios.get(`${this.$store.state[this.resource].apiHierarchyEndpoint}`)
        return data ? data : []
      } catch (e) {
      }
    },
  },
  async created () {
    const nodes = await this.fetchNodes()
    this.$set(this, 'nodes', nodes)
    this.ready = true
  }
}
</script>

<style scoped>

</style>
